import React, { useEffect, useState } from 'react';
import {
    BringzzPageContainer,
    BringzzButton,
    BringzzIcon,
    BringzzBasketProduct,
    BringzzText,
    BringzzImage
} from '@bringzz/components';
import { useNavigation } from 'context/NavigationContext';
import { useOrder } from 'context/OrderContext';

const PrescriptionInvalidPage = () => {
    const { backPress, navigate } = useNavigation();
    const { orderDetails, resetOrderContext } = useOrder()
    const [orderDetailsState, setOrderDetailsState] = useState(orderDetails);

    useEffect(() => {
        if (!orderDetails) {
            resetOrderContext();
            navigate('/home');
        }
    }, [orderDetails, navigate, resetOrderContext]);

    useEffect(() => {
        setOrderDetailsState(orderDetails);
    }, [orderDetails]);

    if (!orderDetails) return null;

    const subtotal = orderDetailsState.products.reduce((acc, product) => acc + product.price, 0);
    const deliveryFee = orderDetailsState.deliveryFee || 2;
    const totalPrice = subtotal + deliveryFee;

    const handleDeleteProduct = (index) => {
        const updatedProducts = orderDetails.products.filter((_, i) => i !== index);
        setOrderDetailsState({ ...orderDetailsState, products: updatedProducts });
    }

    return (
        <BringzzPageContainer
            className="h-full flex flex-col"
            header={{
                left: <BringzzIcon
                    size="18"
                    icon="IconClose"
                    folder="LineIcons"
                    className="cursor-pointer"
                    onClick={backPress}
                />,
                title: "Remove invalid items"
            }}

            footer={
                <div className="flex flex-col p-4 gap-1">

                    <BringzzButton
                        size="lg"
                        className="bg-magic-lilac w-full flex justify-center text-midnight-blue"
                        onClick={() => {
                            // TODO: call customer
                        }}
                    >
                        {"Call customer"}
                    </BringzzButton>

                    <BringzzButton
                        size="lg"
                        className="bg-magic-lilac w-full flex justify-center text-midnight-blue"
                        onClick={() => navigate('/prescription/valid')}
                        disabled={orderDetailsState.products.length === orderDetails.products.length}
                    >
                        {"Continue"}
                    </BringzzButton>

                    <BringzzButton
                        size="lg"
                        className="bg-red-500 w-full flex justify-center text-white"
                        onClick={() => {
                            // TODO: cancel order
                        }}
                    >
                        {"Cancel Order"}
                    </BringzzButton>

                </div>
            }
            footerHover={true}
        >
            <div className="flex flex-col items-center h-full p-4 w-full">
                {orderDetailsState.products && orderDetailsState.products.map((product, index) => {
                    // TODO: get imgUrl from backend
                    const productWithImage = {
                        ...product,
                        imgUrl: product.imgUrl || 'https://placehold.co/75x75'
                    };
                    return (
                        <div key={index + 'product'} className="py-4 flex item-center justify-center gap-6 border-b w-full">
                            <div className="flex items-center">
                                <BringzzImage src={productWithImage.imgUrl} className="w-[75px]" />
                            </div>
                            <div className="flex flex-grow justify-between mt-1">
                                <div className="flex flex-col">
                                    <div className="text-xs">
                                        <BringzzText tag="h5" className="font-regular">
                                            {productWithImage.manufacturer || "Manufacturer"}
                                        </BringzzText>
                                    </div>
                                    <div>
                                        <BringzzText tag="h4" className="font-regular">
                                            {productWithImage.name || "Product Name"}
                                        </BringzzText>
                                    </div>
                                    <div>
                                        <BringzzText tag="h5" className="font-regular">
                                            {productWithImage.amount || "84 Stk | Kapseln"}
                                        </BringzzText>
                                    </div>
                                    <div>
                                        <BringzzText tag="h5" className={"font-normal"}>{productWithImage.inhalt}</BringzzText>
                                    </div>
                                </div>
                                <div className='flex flex-col items-end'>
                                    <BringzzText tag="h3">
                                        € {(productWithImage.quantity * productWithImage.price).toFixed(2)}
                                    </BringzzText>
                                    <BringzzIcon
                                        icon="IconTrashCan"
                                        folder="LineIcons"
                                        size="22"
                                        className="cursor-pointer text-red-500"
                                        onClick={() => handleDeleteProduct(index)}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
                <div className='py-3 w-full'>
                    <div className='flex justify-between'>
                        <BringzzText tag='h4' className="font-normal">Subtotal</BringzzText>
                        <BringzzText tag='h4' className="font-normal">€ {subtotal || 0}</BringzzText>
                    </div>
                    <div className='flex justify-between'>
                        <BringzzText tag='h4' className="font-normal">Delivery fee & handling</BringzzText>
                        <BringzzText tag='h4' className="font-normal">€ {deliveryFee}</BringzzText>
                    </div>
                    <div className='flex justify-between'>
                        <div className='flex space-x-1 items-center'>
                            <BringzzText tag='h4'>Total</BringzzText>
                            <BringzzIcon
                                icon="IconQuestionCircle"
                                folder="LineIcons"
                                className="h-4 w-4 cursor-pointer text-magic-lilac"
                                size="16"
                            />
                        </div>
                        <BringzzText tag='h4'>€ {totalPrice || 0}</BringzzText>
                    </div>
                </div>
            </div>
        </BringzzPageContainer>
    );
};

export default PrescriptionInvalidPage;